import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { Firebase } from './atoms/Firebase'
import { RootProvider } from './atoms/RootProvider'
import { I18nManager } from './i18n'

const Main = () => (
  <Firebase rootPath="/">
    <RootProvider>
      <I18nManager>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nManager>
    </RootProvider>
  </Firebase>
)

const rootElement = document.getElementById('root')
render(<Main />, rootElement)
